export const bolepidemiologicos2025MMEG = [
  {
    "etiqueta_elemento": "1er Informe Trimestral 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/MMEG/1er Informe Trimestral 2025 Morbilidad Materna Extremadamente Grave.pdf",
  },
  {
    "etiqueta_elemento": "2o Informe Trimestral 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/MMEG/2o Informe Trimestral 2025 Morbilidad Materna Extremadamente Grave.pdf",
  },
  {
    "etiqueta_elemento": "3er Informe Trimestral 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/MMEG/3er Informe Trimestral 2025 Morbilidad Materna Extremadamente Grave.pdf",
  },
  {
    "etiqueta_elemento": "4o Informe Trimestral 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/MMEG/4o Informe Trimestral 2025 Morbilidad Materna Extremadamente Grave.pdf",
  },
]